/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PatientMoodDto
 */
export interface PatientMoodDto {
    /**
     * 
     * @type {string}
     * @memberof PatientMoodDto
     */
    'moodType'?: PatientMoodDtoMoodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientMoodDto
     */
    'occurrenceDate'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PatientMoodDtoMoodTypeEnum {
    Good = 'GOOD',
    Average = 'AVERAGE',
    Bad = 'BAD'
}


